// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"745":"d82df1ad","967":"cc775265"}[chunkId] + ".chunk.css";
};